<script>
import { RouterLink } from "vue-router";

import RouteHelper from "@/common/route-helper";
import {
  QUERY_SEARCH_DICTIONARY_KEY,
  QUERY_SEARCH_DIRECTION_KEY,
  QUERY_SEARCH_WORD_KEY
} from "@/router/query-params";

export default {
  name: "SearchLink",
  components: {
    RouterLink
  },
  props: {
    searchDictionary: {
      type: String,
      default: undefined
    },
    searchDirection: {
      type: String,
      default: undefined
    },
    searchWord: {
      type: String,
      default: undefined
    }
  },
  methods: {
    getSearchQueryParams() {
      const routeHelper = new RouteHelper(this.$router);
      return routeHelper.getQueryParams({
        [QUERY_SEARCH_DICTIONARY_KEY]: this.searchDictionary,
        [QUERY_SEARCH_DIRECTION_KEY]: this.searchDirection,
        [QUERY_SEARCH_WORD_KEY]: this.searchWord
      });
    }
  }
};
</script>

<template>
  <RouterLink
    class="search-link-list__item"
    :to="{
      name: 'article',
      query: getSearchQueryParams()
    }"
  >
    <slot></slot>
  </RouterLink>
</template>
